















































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import FullScreenGalleryModal from '~/components/modals/FullScreenGalleryModal.vue';

const Modal = {
  FULLSCREEN: 'fullscreen',
};

@Component({
  components: { FullScreenGalleryModal },
})
export default class PhotosFeed extends Vue {
  @Prop(Array) photos: Array<string>;
  @Prop(Boolean) isLoading: false;

  modal: string = '';
  Modal = Modal;
  photoToOpen: string = '';
  customIndex: number = 0;

  /* Returns first picture's height based on window inner width */
  get firstPictureHeight () {
    if (process.client) return window.innerWidth >= 768 ? '437px' : '237px';
    return '437px';
  }

  /*
    Returns photos length left that aren't displayed (which means the 5
    following pictures in the array)
  */
  get photosLeft () {
    return this.photos.length - 5;
  }

  /* Returns the 4 pictures after the first one */
  get fourLastPhotos () {
    if (this.photos.length) {
      return this.photos.slice(1, 5);
    }
    return [{}, {}, {}, {}];
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/destination-placeholder.png";
  }
}
